export const roleOptions = [
  { code: 'HK_ADMIN', label: 'HK-Admin' },
  { code: 'GROUP_ADMIN', label: 'Group-Admin' },
  { code: 'SUPPORT', label: 'Support' },
  { code: 'GENERAL_USER', label: 'General user' },
  { code: 'STORE_ADMIN', label: 'Store-Admin' },
  { code: 'SALESPERSON', label: 'Salesperson' },
];

export const defaultPermissions = (toolNames) => {
  const map = {};

  roleOptions.forEach((role) => {
    map[role.label] = {};
    toolNames.forEach((toolName) => {
      map[role.label][toolName] = role.code === 'HK_ADMIN';
    });
  });

  return map;
};

export const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
};
